module.exports = __webpack_public_path__ + "img/scale.e9ed4aec.svg";